import { useMemo } from "react";
import { useQueryState } from "src/hooks/queryState";

export const usePaginationPage = () => {
  const [pageQuery, setPageQuery] = useQueryState<string>("page", "1");

  const page = useMemo(() => Number(pageQuery), [pageQuery]);

  const setpage = (page: number) => {
    setPageQuery(String(page));
  };

  return [page, setpage] satisfies [number, (page: number) => void];
};
